import { createAsyncThunk } from "@reduxjs/toolkit";
import type { SignInLogEntry } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchSignins = createAsyncThunk(
	"signins/fetch",
	apiGet<SignInLogEntry[]>(
		(authConfig, { params: { from, to } }: any) =>
			authConfig.MS_GRAPH_API_ENDPOINTS.GET_SIGNINS(from, to),
		[SCOPES.GRAPH_READ],
	),
);
